import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';


moment.locale('es-us');

export const DatosPaquete = () => {
    const cliente = useSelector(state => state.client)
    const paquete= {...cliente.paquete};
    return (
        <div className="card">
            <div className="card-body">
                <div className="text-left mt-3">
                    <h4 className="mb-4">Datos del Paquete</h4>

                    <p className="text-muted mb-2 font-13"><strong>Paquete :</strong><span className="ml-2 text-uppercase">{paquete.origen} - {paquete.destino} / {paquete.calendario} {paquete.anio}</span></p>

                    <p className="text-muted mb-2 font-13"><strong>Hotel :</strong> <span className="ml-2 text-uppercase">{paquete.hotel}</span></p>

                    <p className="text-muted mb-2 font-13"><strong>Fecha para liquidar :</strong> <span className="ml-2">{moment(paquete.liquidacion_normal).format('DD/MMM/YYYY')}</span></p>
                </div>
            </div>
        </div>
    )
}
